import { Navigate, useLocation, Outlet } from 'react-router';

// hooks
import useAuth from '@hooks/use-auth';

// UI
import PageLoading from '@components/page-loading';

// TEMP
// const IGNORED_PATHS = ['/login'];

const LOGIN_PATH = '/login';

const ForNotAuthenticatedRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoading />;
  }

  const currentPathname = location.pathname;

  // if (isAuthenticated && !IGNORED_PATHS.includes(currentPathname)) {
  //   return <Navigate replace to="/account" state={{ from: location }} />;
  // }

  // if (isAuthenticated) {
  //   console.log('current user: ', user);

  //   return <Navigate replace to="/account" state={{ from: location }} />;
  // }

  if (isAuthenticated) {
    if (currentPathname === LOGIN_PATH && user?.total_cards === 0) {
      return <Navigate replace to="/main" state={{ from: location }} />;
    }

    return <Navigate replace to="/account" state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ForNotAuthenticatedRoute;
